/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard/dashboard'
import { Route as DashboardEventsRouteImport } from './routes/_dashboard/events'
import { Route as DashboardMyPrizesRouteImport } from './routes/_dashboard/my-prizes'
import { Route as EventSlugRouteImport } from './routes/event.$slug'
import { Route as DashboardEventsIndexRouteImport } from './routes/_dashboard/events/index'
import { Route as DashboardEventsSlugRouteImport } from './routes/_dashboard/events/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEventsRoute = DashboardEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMyPrizesRoute = DashboardMyPrizesRouteImport.update({
  id: '/my-prizes',
  path: '/my-prizes',
  getParentRoute: () => DashboardRoute,
} as any)
const EventSlugRoute = EventSlugRouteImport.update({
  id: '/event/$slug',
  path: '/event/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardEventsIndexRoute = DashboardEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardEventsRoute,
} as any)
const DashboardEventsSlugRoute = DashboardEventsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => DashboardEventsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/events': typeof DashboardEventsRouteWithChildren
  '/my-prizes': typeof DashboardMyPrizesRoute
  '/event/$slug': typeof EventSlugRoute
  '/events/$slug': typeof DashboardEventsSlugRoute
  '/events/': typeof DashboardEventsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/my-prizes': typeof DashboardMyPrizesRoute
  '/event/$slug': typeof EventSlugRoute
  '/events/$slug': typeof DashboardEventsSlugRoute
  '/events': typeof DashboardEventsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_dashboard/events': typeof DashboardEventsRouteWithChildren
  '/_dashboard/my-prizes': typeof DashboardMyPrizesRoute
  '/event/$slug': typeof EventSlugRoute
  '/_dashboard/events/$slug': typeof DashboardEventsSlugRoute
  '/_dashboard/events/': typeof DashboardEventsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/dashboard'
    | '/events'
    | '/my-prizes'
    | '/event/$slug'
    | '/events/$slug'
    | '/events/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/dashboard'
    | '/my-prizes'
    | '/event/$slug'
    | '/events/$slug'
    | '/events'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/_dashboard/dashboard'
    | '/_dashboard/events'
    | '/_dashboard/my-prizes'
    | '/event/$slug'
    | '/_dashboard/events/$slug'
    | '/_dashboard/events/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  WelcomeRoute: typeof WelcomeRoute
  EventSlugRoute: typeof EventSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/events': {
      id: '/_dashboard/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof DashboardEventsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/my-prizes': {
      id: '/_dashboard/my-prizes'
      path: '/my-prizes'
      fullPath: '/my-prizes'
      preLoaderRoute: typeof DashboardMyPrizesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/event/$slug': {
      id: '/event/$slug'
      path: '/event/$slug'
      fullPath: '/event/$slug'
      preLoaderRoute: typeof EventSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/events/': {
      id: '/_dashboard/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof DashboardEventsIndexRouteImport
      parentRoute: typeof DashboardEventsRoute
    }
    '/_dashboard/events/$slug': {
      id: '/_dashboard/events/$slug'
      path: '/$slug'
      fullPath: '/events/$slug'
      preLoaderRoute: typeof DashboardEventsSlugRouteImport
      parentRoute: typeof DashboardEventsRoute
    }
  }
}

interface DashboardEventsRouteChildren {
  DashboardEventsSlugRoute: typeof DashboardEventsSlugRoute
  DashboardEventsIndexRoute: typeof DashboardEventsIndexRoute
}

const DashboardEventsRouteChildren: DashboardEventsRouteChildren = {
  DashboardEventsSlugRoute: DashboardEventsSlugRoute,
  DashboardEventsIndexRoute: DashboardEventsIndexRoute,
}

const DashboardEventsRouteWithChildren = DashboardEventsRoute._addFileChildren(
  DashboardEventsRouteChildren,
)

interface DashboardRouteChildren {
  DashboardDashboardRoute: typeof DashboardDashboardRoute
  DashboardEventsRoute: typeof DashboardEventsRouteWithChildren
  DashboardMyPrizesRoute: typeof DashboardMyPrizesRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardDashboardRoute: DashboardDashboardRoute,
  DashboardEventsRoute: DashboardEventsRouteWithChildren,
  DashboardMyPrizesRoute: DashboardMyPrizesRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  WelcomeRoute: WelcomeRoute,
  EventSlugRoute: EventSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
